<template>
  <ModalDialog
    header-text="Thank you for your submission"
    @closeModal="closeModal"
    open
  >
    <template v-slot:content>
      <div class="inspection__results">
        <p>{{ comment }}</p>
        <p v-if="!submissionFailed" class="created-visit-label">
          {{ visitId }}
        </p>
        <div v-if="!submissionFailed && failedAttachments.length > 0">
          <p>
            Your Report has been successfully submitted. However the following
            attachment(s) were not properly uploaded:
          </p>
          <ul>
            <li v-for="attachment in failedAttachments" :key="attachment">
              {{ attachment }}
            </li>
          </ul>
          <p>
            Please resend failed EIR attachments to the RC. Please make sure to
            include the Visit ID.
          </p>
        </div>
        <p v-if="!submissionFailed">A Confirmation e-mail will be forwarded</p>
        <p v-if="!efrAvailable">
          This Visit ID is not available for Electronic Reimbursement. For
          payment, please submit a hard copy (paper form). If you have any
          questions, contact the accounting department.
        </p>
        <Button type="button" themeColor="secondary" @click="closeModal"
          >Return to My Inspection Reports</Button
        >
        <p>
          To apply for Financial Reimbursement, return to the Visits Menu and
          click "Manage Your EFR Electronic Financial Report"
        </p>
        <p>
          Note: All EIRs for a trip should be submitted before continuing to the
          (EFR) Electronic Financial Report.
        </p>
      </div>
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";
import { Button } from "@progress/kendo-vue-buttons";
import { computed } from "vue";

const emit = defineEmits<{
  (e: "closeModal"): void;
}>();

const props = defineProps<{
  visitId: number;
  efrAvailable: boolean;
  failedAttachments: string[];
}>();

const defaultComment =
  "Please reference the following VisitID for tracking purposes:";
const errorComment = "There was an error processing your request.";

const submissionFailed = computed(() => {
  return props.visitId <= 1;
});

const comment = computed(() => {
  if (submissionFailed.value) return errorComment;
  return defaultComment;
});

const closeModal = function () {
  emit("closeModal");
};
</script>

<style lang="scss">
.inspection__results {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  .created-visit-label {
    font-size: 24px;
    font-weight: bold;
  }
}
</style>
